import { render, staticRenderFns } from "./type20.vue?vue&type=template&id=03ed968c&scoped=true"
import script from "./type20.vue?vue&type=script&lang=js"
export * from "./type20.vue?vue&type=script&lang=js"
import style0 from "./type20.vue?vue&type=style&index=0&id=03ed968c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ed968c",
  null
  
)

export default component.exports